import { render, staticRenderFns } from "./IndividualCaseCreateDashboard.vue?vue&type=template&id=8e069376&scoped=true&"
import script from "./IndividualCaseCreateDashboard.vue?vue&type=script&lang=js&"
export * from "./IndividualCaseCreateDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e069376",
  null
  
)

export default component.exports